import Loader from "react-loader-spinner";
import { useHistory } from 'react-router-dom';
import { useEffect, useRef, useState } from "react";
import { Table, Modal, Button } from 'react-bootstrap';
import { useDispatch } from "react-redux";
import { X, PlusSquare, Trash, PencilFill, DashCircle } from 'react-bootstrap-icons';
import { setDialog } from '../store/api/GetAllProduct';
import { addNewCustomerStatus, deleteCustomerStatus, editCustomerStatus, editPreCustomerStatus, getCustomerStatusList } from "../store/api/CustomerApi";
import { setErrorDialog } from "../../store/api/CommonFunctions";

const ModalPreCustomerStatus = () => {
    const history = useHistory();
    const frmStatus = useRef();
    const currentStatus = useRef({});
    const [statusList, setstatusList] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [currentRow, setCurrentRow] = useState(null);
    const dispatch = useDispatch();

    const close = () => {
        history.goBack();
    }
    const addStatus = () => {
        if (!currentStatus.current.Status ||
            currentStatus.current.Status === '') {
            return;
        }
        const onSuccess = (res) => {
            const lstStage = statusList.slice();
            currentStatus.current.ID = res.ID;
            const st = { ...currentStatus.current };
            lstStage.push(st);
            currentStatus.current = {};
            frmStatus.current.reset();
            setstatusList(lstStage);
        }
        dispatch(addNewCustomerStatus(currentStatus.current, onSuccess));
    }
    const onDeleteStatus = (id) => {
        const lstStage = statusList.filter(s => s.ID !== id);
        setstatusList(lstStage);
    }
    function editStatus() {
        if ((currentRow.Status ?? "") === "") {
            return;
        }
        const onSuccess = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "ویرایش وضعیت");
            }
            else {
                const s = statusList.find(s => Number(s.ID) === Number(currentRow.ID));
                if (s) { s.Status = currentRow.Status };
                setCurrentRow(null);
                setEditMode(false);
            }
        }
        editCustomerStatus(currentRow, onSuccess)
    }
    function cancelStatus() {
        setCurrentRow(null);
        setEditMode(false);
    }
    function gotoEditMode(row) {
        setCurrentRow(row);
        setEditMode(true);
    }
    useEffect(() => {
        setstatusList("PENDING");
        getCustomerStatusList(setstatusList);
    }, []);
    return (
        <Modal show={true} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header style={{ backgroundColor: '#e40375' }}>مدیریت وضعیت مشتری<span onClick={close} style={{ cursor: "pointer" }}><X size={20} /></span></Modal.Header>
            <Modal.Body>
                <form ref={frmStatus}>
                    {!editMode &&
                        <div className="row" style={{ paddingRight: "10px" }}>
                            <div className="col-md-7 col-sm-7" style={{ padding: "3px" }}>
                                <input type="text" className="tableRowInput" placeholder="نام وضعیت" onChange={e => currentStatus.current.Status = e.target.value} />
                            </div>
                            <div className="col-md-3 col-sm-3" style={{ padding: "3px" }}>
                                <input type="number" className="tableRowInput" placeholder="ترتیب نمایش" onChange={e => currentStatus.current.ItemOrder = e.target.value} />
                            </div>
                            <div className="col-md-1 col-sm-1" style={{ padding: "2px" }}>
                                <Button className="group-Btn-smalll" onClick={addStatus}><PlusSquare size={18} /></Button>
                            </div>
                        </div>
                    }
                    {
                        editMode && currentRow?.Status &&
                        <div className="row" style={{ paddingRight: "10px" }}>
                            <div className="col-md-7 col-sm-7" style={{ padding: "3px" }}>
                                <input type="text" className="tableRowInput" placeholder="نام وضعیت" defaultValue={currentRow.Status} onChange={e => currentRow.Status = e.target.value} />
                            </div>
                            <div className="col-md-2 col-sm-2" style={{ padding: "2px" }}>
                                <Button className="group-Btn-smalll" onClick={editStatus}><PencilFill size={18} /></Button>
                                <Button className="group-Btn-smalll" onClick={cancelStatus} variant="danger"><DashCircle size={18} /></Button>
                            </div>
                        </div>
                    }
                </form>
                <hr style={{ margin: "5px" }} />
                <Table responsive className="fixedTable mt-2">
                    <thead>
                        <tr>
                            <th style={{ width: "50%" }}>نام وضعیت</th>
                            <th style={{ width: "30%" }}>ترتیب نمایش</th>
                            <th style={{ width: "20%" }}>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(statusList === "PENDING") &&
                            <tr>
                                <td colSpan={3} style={{ textAlign: "center" }}>
                                    <Loader type="BallTriangle" color="rgb(228, 3, 117)" height={20} width={20} />
                                </td>
                            </tr>
                        }
                        {statusList && Array.isArray(statusList) &&
                            statusList.map((item, i) =>
                                <tr key={i} className="resultTableRow" onClick={()=>gotoEditMode(item)}>
                                    <td style={{ width: "50%" }}>{item.Status}</td>
                                    <td style={{ width: "30%" }}>{item.ItemOrder ?? "--"}</td>
                                    <td style={{ width: "20%" }}>
                                        <Trash className="rowBtn" color="red" size={16}
                                            onClick={() => {
                                                dispatch(setDialog({
                                                    status: 'show',
                                                    arrayBtn: ['yes', 'no'],
                                                    dialogTitle: 'حذف وضعیت',
                                                    dialogText: 'آیا از حذف مطمئن هستید؟',
                                                    okOperation: deleteCustomerStatus(item.ID, onDeleteStatus)
                                                }))
                                            }} />
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </Table>
            </Modal.Body>
        </Modal>
    )
}
export default ModalPreCustomerStatus;